import { render, staticRenderFns } from "./pageEditor.vue?vue&type=template&id=19e81720&scoped=true"
import script from "./pageEditor.vue?vue&type=script&lang=js"
export * from "./pageEditor.vue?vue&type=script&lang=js"
import style0 from "./pageEditor.vue?vue&type=style&index=0&id=19e81720&prod&scoped=true&lang=css"
import style1 from "./pageEditor.vue?vue&type=style&index=1&id=19e81720&prod&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e81720",
  null
  
)

export default component.exports